<template>
        <CnaeLists scope="account" />
</template>

<script setup lang="ts">
import CnaeLists from '@/components/CnaeLists.vue';
</script>
